import { Skeleton } from "antd";
import React from "react";

const LazyloadImage: React.FC<
  { Loaded: boolean; active?: boolean } & React.DetailedHTMLProps<
    React.ImgHTMLAttributes<HTMLImageElement>,
    HTMLImageElement
  >
> = ({ Loaded, active = false, ...imgProps }) => {
  if (Loaded) {
    return <img {...imgProps} />;
  }

  return <Skeleton.Image {...imgProps} active={active} />;
};

export default LazyloadImage;
